export function getCurrencySymbol(
  code: string,
  format: 'wide' | 'narrow',
  locale = 'en-US',
): string {
  const currencyDisplay = format === 'narrow' ? 'narrowSymbol' : 'symbol';

  try {
    const parts = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      currencyDisplay,
    } as unknown as Intl.NumberFormatOptions).formatToParts(1);

    return parts.find((part) => part.type === 'currency')?.value ?? code;
  } catch (error) {
    return code;
  }
}
